import styled from "styled-components";

export const SettingsConfigPageStyle = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    max-width: 1280px;
    padding: 10px 10px;
    border: 1px solid rgba(45, 45, 45, 0.15);
    max-width: 1280px;
    width: 100%;
    min-height: 60vh;
    background-color: #fff !important;
    margin: 0 auto;

    .topPageContainer {
        display: flex;
        position: relative;
        width: 100%;
    }

    .instructionsContainer {
        cursor: pointer;
        position: absolute;
        right: 5%;
        display: flex;
        align-items: center;
        border-radius: 8px;
        padding: 5px 10px !important;
        box-shadow: 0px 0px 2px #8888889e;
        transition: 0.3s;
        background-color: #8888883e;
        &:hover {
            background-color: #8888889e;
        }
    }

    .instructionsContainer p {
        margin: 0;
        padding: 0;
    }

    h2 {
        margin-top: 40px;
        text-align: center;
        width: 100%;
    }

    .inputAndLoadingContainer {
        position: relative;
    }

    .inputs {
        width: 600px;
    }

    .toggle {
        display: flex;
        flex-direction: column-reverse;
    }

    .asaasAccounts {
        width: 600px;
        max-width: 100%;
        text-align: left;
        display: flex;
        flex-direction: column;
        gap: 24px;
        margin: 0 auto 24px;
    }

    .asaasAccountGroup {
        border: 1px solid rgba(45, 45, 45, 0.15);
        border-radius: 8px;
        padding: 16px;
        background-color: #fafafa;
    }

    .asaasAccountGroup h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
        text-align: left;
        color: #1e293b;
    }

    .asaasAccountGroupHeader {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        margin-bottom: 16px;
    }

    @media (max-width: 740px) {
        .inputs,
        .asaasAccounts {
            width: 100%;
        }

        @media (max-width: 400px) {
            box-shadow: none;
        }
    }
`;
